import { Container, ContainerGutter, CTA, Spinner, ThemeProvider } from '@volkswagen-onehub/components-core';
import { Download, LinkExternal } from '@volkswagen-onehub/icons-core';
import React from 'react';
import styled from 'styled-components';
import { PdfHuchaContent } from '../../../shared/components/pdf-hucha-content';
import { useHuchaPdfGenerator } from '../../../shared/hooks/use-hucha-pdf-generator';
import { useHuchaPopup } from '../../../shared/hooks/use-hucha-popup';
import { HuchaVentaValues } from '../../../shared/models/hucha-values';
import { useHuchaVentaLayerContent } from '../../hooks/use-hucha-venta-layer-content';

const StyledCTA = styled(CTA)`
	@media (max-width: 959px) {
		width: 100%;
	}
`;

export const HuchaStandardButtons = ({ huchaValues }: { huchaValues: HuchaVentaValues }) => {
	const targetRefPDF = React.useRef<HTMLDivElement>(null);
	const { handlePdfDownloadClick, isDownloading, isPdfReady } = useHuchaPdfGenerator(huchaValues, targetRefPDF);
	const { huchaVentaPdfLayerContent, huchaVentaPopupLayerContent } = useHuchaVentaLayerContent(huchaValues);
	const { handlePopupOpen } = useHuchaPopup({ huchaValues, layerContent: () => huchaVentaPopupLayerContent });

	return (
		<>
			<ThemeProvider theme="inverted">
				<Container
					wrap="always"
					stretchContent
					verticalAlign="center"
					horizontalAlign="center"
					gutter={ContainerGutter.static300}
				>
					<StyledCTA
						tag="button"
						emphasis="secondary"
						onClick={handlePdfDownloadClick}
						icon={isDownloading ? <Spinner /> : <Download variant="small" />}
					>
						{isDownloading ? 'Descargando' : 'Descargar ahorro acumulado'}
					</StyledCTA>
					<StyledCTA tag="button" emphasis="primary" onClick={handlePopupOpen} icon={<LinkExternal variant="small" />}>
						Más sobre tus ahorros
					</StyledCTA>
				</Container>
			</ThemeProvider>
			{isPdfReady && <PdfHuchaContent targetRef={targetRefPDF} layerContent={() => huchaVentaPdfLayerContent} />}
		</>
	);
};
